
// @ts-nocheck

import { Component, Prop } from 'vue-property-decorator'
import Vue from 'vue'
import { Vessel } from '@/models/Vessel'
import { PhoneCountryCode } from '@/models/PhoneCountryCode'
import User from '@/models/User'

@Component
export default class VesselEditor extends Vue {
	@Prop({ required: true })
	vessel!: Vessel

	@Prop({ default: true })
	isRegistered!: boolean

	@Prop({ default: false })
	activeVessel!: boolean

	name: string | null = null
	euNumber: number | null = null
	tonnage: number | null = null
	length: number | null = null
	insurance: string | null = null
	email: string | null = null
	phoneCountryCode: PhoneCountryCode | null = null
	phoneNumber: string = ''
	skipperName: string | null = null
	mmsi: string | null = null
	width: number | null = null
	draught: number | null = null
	emptyWeight: number | null = null

	isLoading = true
	phoneCountryCodes: Array<PhoneCountryCode> = []

	async created() {
		const phoneCountryCodesQuery = PhoneCountryCode.fetchAllLazy()

		if (this.vessel) {
			this.name = this.vessel.name as string
			this.euNumber = this.vessel.euNumber as number
			this.tonnage = this.vessel.tonnage as number
			this.length = this.vessel.length as number
			this.insurance = this.vessel.insurance as string
			this.email = this.vessel.email as string
			this.phoneCountryCode = this.vessel.getPhoneCountryCode()
			this.phoneNumber = this.vessel.phoneNumber as string
			this.skipperName = this.vessel.skipperName as string
			this.mmsi = this.vessel.mmsi as string
			this.width = this.vessel.width as number
			this.draught = this.vessel.draught as number
			this.emptyWeight = this.vessel.emptyWeight as number
		}

		this.phoneCountryCodes = await phoneCountryCodesQuery
		this.isLoading = false
	}

	async validate() {
		return await this.$validator.validateAll()
	}

	async submit(): Promise<Vessel> {
		this.vessel.name = this.name
		this.vessel.tonnage = this.tonnage
		this.vessel.length = this.length
		this.vessel.insurance = this.insurance
		this.vessel.euNumber = this.euNumber
		this.vessel.email = this.email
		this.vessel.setPhoneCountryCode(this.phoneCountryCode)
		this.vessel.phoneNumber = this.phoneNumber
		this.vessel.skipperName = this.skipperName
		this.vessel.mmsi = this.mmsi
		this.vessel.width = this.width
		this.vessel.draught = this.draught
		this.vessel.emptyWeight = this.emptyWeight
		this.vessel.isRegistered = this.isRegistered

		await this.vessel.save()

		if (this.activeVessel) {
			// refresh state of profile completeness
			await User.sync(true)
		}
		return this.vessel
	}
}
